import React, { memo } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { makeSelectVirtualizedTableColumnLabel } from 'services/virtualizedTable/selectors';
import { VirtualizedTableColumnKey } from 'services/virtualizedTable/types';

export interface OwnProps {
    columnKey: VirtualizedTableColumnKey;
}

export interface ConnectedProps {
    columnLabel?: ReturnType<
        ReturnType<typeof makeSelectVirtualizedTableColumnLabel>
    >;
}
export type Props = OwnProps & ConnectedProps;

export const VirtualizedTableColumnLabelComponent = (
    props: Props
): React.ReactElement | null => {
    const { columnLabel } = props;

    if (columnLabel) {
        return <React.Fragment>{columnLabel}</React.Fragment>;
    }

    return null;
};

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    columnLabel: makeSelectVirtualizedTableColumnLabel()
});

export default connect(mapStateToProps)(
    memo(VirtualizedTableColumnLabelComponent)
);
